import { IWSAssembleia } from './WSAssembleiasReducer';

export const WS_ASSEMBLEIAS_ACTIONS_SEND_MESSAGE =
  'WS_ASSEMBLEIAS_ACTIONS_SEND_MESSAGE';
export const WS_ASSEMBLEIAS_ACTIONS_MANUAL_REFRESH =
  'WS_ASSEMBLEIAS_ACTIONS_MANUAL_REFRESH';
export const WS_ASSEMBLEIAS_ACTIONS_OPEN = 'WS_ASSEMBLEIAS_ACTIONS_OPEN';
export const WS_ASSEMBLEIAS_ACTIONS_ON_MESSAGE =
  'WS_ASSEMBLEIAS_ACTIONS_ON_MESSAGE';
export const WS_ASSEMBLEIAS_ACTIONS_CLOSE = 'WS_ASSEMBLEIAS_ACTIONS_CLOSE';
export const WS_ASSEMBLEIAS_ACTIONS_ON_ERROR =
  'WS_ASSEMBLEIAS_ACTIONS_ON_ERROR';

export interface WSAssembleiasActionsSendMessage {
  type: typeof WS_ASSEMBLEIAS_ACTIONS_SEND_MESSAGE;
  payload: IWSAssembleia;
}

export interface WSAssembleiasActionsManualRefresh {
  type: typeof WS_ASSEMBLEIAS_ACTIONS_MANUAL_REFRESH;
}

export interface WSAssembleiasActionsOpen {
  type: typeof WS_ASSEMBLEIAS_ACTIONS_OPEN;
}

export interface WSAssembleiasActionsOnMessage {
  type: typeof WS_ASSEMBLEIAS_ACTIONS_ON_MESSAGE;
  payload: IWSAssembleia;
}

export interface WSAssembleiasActionsClose {
  type: typeof WS_ASSEMBLEIAS_ACTIONS_CLOSE;
}

export interface WSAssembleiasActionsOnError {
  type: typeof WS_ASSEMBLEIAS_ACTIONS_ON_ERROR;
  payload: any;
}

export type WSAssembleiasActionTypes =
  | WSAssembleiasActionsSendMessage
  | WSAssembleiasActionsManualRefresh
  | WSAssembleiasActionsOpen
  | WSAssembleiasActionsOnMessage
  | WSAssembleiasActionsClose
  | WSAssembleiasActionsOnError;
